import './inc/retail_user.js';
import './inc/popup.js';
import './inc/card_media.js';
import './partial/oifilter.js';
import Swiper, { Navigation, Pagination } from 'swiper';
import { Fancybox, Panzoom } from '@fancyapps/ui';
import * as bootstrap from 'bootstrap';

// Install Swiper Navigation module
Swiper.use([Navigation]);

// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;
window.Swiper = Swiper;

// To open nav tab panes via anchor links, use class .btn-tab
var triggerTabList = [].slice.call(document.querySelectorAll('.btn-tab'));

    triggerTabList.forEach(function (triggerEl) {
    var tabTrigger = new bootstrap.Tab(triggerEl);
    var hash = '#' + triggerEl.href.split('#')[1];
    var tabBtn = document.querySelector(hash + '-tab');

    triggerEl.addEventListener('click', function (event) {
        event.preventDefault();
        tabBtn.click();
    });
});

// Set up nav

const navWrapper = document.getElementById('nav-wrapper');

let navHeight = navWrapper.getBoundingClientRect().height;
document.documentElement.style.setProperty('--nav-height', `${navHeight}px`);

// Set up subnav

const subnav = document.getElementById('subnav');
if (subnav) {
    const subnavHeight = subnav.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--subnav-height', `${subnavHeight}px`);
}

// Add class to main navbar on scroll

const siteNav = document.getElementById('site-nav');

window.addEventListener('scroll', function() {
    let scroll = window.scrollY;
    if (scroll > siteNav.offsetTop) {
        siteNav.classList.add('scrolled');
    } else {
        siteNav.classList.remove('scrolled');
    }
});

// Focus search input when search modal opens

const modalSearch = document.getElementById('modal-search');
const inputSearch = document.getElementById('sitesearch');

modalSearch.addEventListener('shown.bs.modal', () => {
    inputSearch.focus();
});

// Panzoom
const panzoom = document.querySelector('.panzoom');
const panzoom_reset = document.querySelector('.panzoom-reset');
const panZoomImg = document.querySelector('.panzoom__content');
const fpImgLink = document.querySelectorAll('[data-imgurl]');

if (panzoom) {
    const myPanzoom = new Panzoom(panzoom, {
        minScale: 0.5,
        maxScale: 3,
    });
    panzoom_reset.addEventListener('click', function(event) {
        myPanzoom.zoomTo(1);
    })
}

for (const link of fpImgLink) {
    link.addEventListener('click', function() {
        fpImgLink.forEach((e) => { e.classList.remove('active-bg') })
        link.classList.add('active-bg');
        var imgUrl = link.dataset.imgurl;
        panZoomImg.src = imgUrl;
    });
}

/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */

// Tracks fancybox image views.
let fancyboxEventBlock = false;

/** Abstracted event action handler
 * @param {import('@fancyapps/ui').Fancybox} fancybox
 */
const doFancyboxOiEvent = (fancybox) => {
    if (fancybox.options.trigger.dataset.oiEventName) {
        let oi_event_name = fancybox.options.trigger.dataset.oiEventName;
        if ('undefined' != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ('undefined' != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
}

// Bind actions to Fancybox events
Fancybox.bind('[data-fancybox]', {
    on: {
        initCarousel: (fancybox) => {
            if (!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true

                // Do Fancybox event
                doFancyboxOiEvent(fancybox)

                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if (!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false
        },
    },
});

// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener('load', function() {
    oi.utils.wrap_oi_aspect();
}, false);
